import { Builder } from '@builder.io/react';
import {
    BUILDER_BLOG_COMPONENTS_NAMES,
    BUILDER_DIVIDER_NAMES,
    BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES,
    BUILDER_HERO_COMPONENTS_NAMES,
} from './src/components/builder/BuilderComponentsName';

/**
 * Import all custom components so you can use in the builder.io editor
 * https://www.builder.io/c/docs/custom-react-components
 */

// Component Library Css
import '@milanlaser/mlcomponents/dist/mlcomponents.css';

// Design Tokens
import { milanDesignTokens } from './src/components/builder/utils/builderDesignTokens';

// Dividers
import './src/components/builder/dividers/WaxingCostPerYear.builder';
import './src/components/builder/dividers/AffordablePlansDivider.builder';
import './src/components/builder/dividers/RatingsDivider.builder';
import './src/components/builder/dividers/LipsOrUnderArmsDivider.builder';
import './src/components/builder/dividers/RatingsAndLipsOrUnderarmDivider.divider';
import './src/components/builder/dividers/SectionDivider.builder';
import './src/components/builder/dividers/LocationsDivider.builder';
import './src/components/builder/dividers/ScrollingBanner.builder';
import './src/components/builder/dividers/PullQuote.builder';

// Sections
import './src/components/builder/sections/PopularBlogs.builder';
import './src/components/builder/sections/UnlimitedPackage2.builder';
import './src/components/builder/sections/UnlimitedPackage.builder';
import './src/components/builder/sections/WhyMilanLHRIdeal.builder';
import './src/components/builder/sections/LHRBenefits.builder';
import './src/components/builder/sections/HowLHRWorks.builder';
import './src/components/builder/sections/CreditApproval.builder';
import './src/components/builder/sections/MilanCost.builder';
import './src/components/builder/sections/AboutMilanSection.builder';
import './src/components/builder/sections/AboutAuthor.builder';

// Interactive Sections
import './src/components/builder/interactive-sections/ShavingWaxingCalc.builder';
import './src/components/builder/interactive-sections/S1Hero.builder';
import './src/components/builder/interactive-sections/S2Icons.builder';
import './src/components/builder/interactive-sections/S3How.builder';
import './src/components/builder/interactive-sections/S4WhyChoose.builder';
import './src/components/builder/interactive-sections/S5BeforeAfter.builder';
import './src/components/builder/interactive-sections/S6FAQs.builder';
import './src/components/builder/interactive-sections/S7SubCategories.builder';
import './src/components/builder/interactive-sections/S8MixedMedia.builder';
import './src/components/builder/interactive-sections/S9PressRelease.builder';
import './src/components/builder/interactive-sections/S10PressReleasePost.builder';
import './src/components/builder/interactive-sections/S11Awards.builder';
import './src/components/builder/interactive-sections/S12Reviews.builder';
import './src/components/builder/interactive-sections/S13LHR.builder';
import './src/components/builder/interactive-sections/S14WhatToExpect.builder';
import './src/components/builder/interactive-sections/S15TwoSections.builder';
import './src/components/builder/interactive-sections/S16BackgroundImage.builder';
import './src/components/builder/interactive-sections/BuilderTestComponent.builder';
import './src/components/builder/interactive-sections/S17ToggleTabs.builder';
import './src/components/builder/interactive-sections/S18VideoBackground.builder';
import './src/components/builder/interactive-sections/S19Timeline.builder';
import './src/components/builder/interactive-sections/S20Choices.builder';
import './src/components/builder/interactive-sections/S31StateHero.builder';
import './src/components/builder/interactive-sections/S32MapView.builder';
import './src/components/builder/interactive-sections/S33CondensedSpecial.builder';
import './src/components/builder/interactive-sections/S34Dropdowns.builder';
import './src/components/builder/interactive-sections/S35ClinicInfo.builder';
import './src/components/builder/interactive-sections/S36Staff.builder';
import './src/components/builder/interactive-sections/S37ReviewsOverall.builder';
import './src/components/builder/interactive-sections/S37ReviewsCityOverall.builder';
import './src/components/builder/interactive-sections/S38NearbyLocations.builder';
import './src/components/builder/interactive-sections/S39AdBanner.builder';
import './src/components/builder/interactive-sections/S40Breadcrumbs.builder';

// Videos
import './src/components/builder/videos/ReasonsLHRVimeo.builder';
import './src/components/builder/videos/WhatOurCustomersSay';

// Hero
import './src/components/builder/hero/HeroWithImageAndLinkOnly.builder';
import './src/components/builder/hero/SpecialsHero.builder';
import './src/components/builder/hero/SpecialsHero.builder.V2';
import './src/components/builder/hero/AuthorAvatarHero.builder';
import './src/components/builder/hero/LandingPageHero.builder';
import './src/components/builder/hero/BrandPartnerHero.builder';

// Blog Sections
import './src/components/builder/sections/BlogPostHero.builder';
import './src/components/builder/sections/ConsulationSection.builder';
import './src/components/builder/sections/SectionWithImage.builder';
import './src/components/builder/sections/BlogLayout.builder';
import './src/components/builder/sections/BlogTextSection.builder';
import './src/components/builder/sections/BlogsFAQs.builder';
import './src/components/builder/sections/BlogHeroCarousel.builder';
import './src/components/builder/blogs/OurLatestBlog.builder';

// Register a custom insert menu to add your custom components here
Builder.register('editor.settings', milanDesignTokens);

// Dividers
// Register a custom insert menu to add your custom components here
// Dividers
Builder.register('insertMenu', {
    name: 'Dividers',
    items: [
        { name: BUILDER_DIVIDER_NAMES.WaxingCostPerYear },
        { name: BUILDER_DIVIDER_NAMES.AffordablePlansDivider },
        { name: BUILDER_DIVIDER_NAMES.RatingsDivider },
        { name: BUILDER_DIVIDER_NAMES.LipsOrUnderArmsDivider },
        { name: BUILDER_DIVIDER_NAMES.RatingsAndLipsOrUnderarmDivider },
        { name: BUILDER_DIVIDER_NAMES.SectionDivider },
        { name: BUILDER_DIVIDER_NAMES.LocationsBanner },
        { name: BUILDER_DIVIDER_NAMES.ScrollingBanner },
    ],
});

// Sections
Builder.register('insertMenu', {
    name: 'Static Sections',
    items: [
        { name: BUILDER_DIVIDER_NAMES.UnlimitedPackage },
        { name: BUILDER_DIVIDER_NAMES.UnlimitedPackage2 },
        { name: BUILDER_DIVIDER_NAMES.MilanCost },
        { item: BUILDER_DIVIDER_NAMES.WhyMilanLHRIsIdeal, name: 'Why Milan LHR is Ideal' },
        { item: BUILDER_DIVIDER_NAMES.HowLHRWorks, name: 'How LHR Works' },
        { name: BUILDER_DIVIDER_NAMES.CreditApproval },
        { item: BUILDER_DIVIDER_NAMES.LHRBenefits, name: 'LHR Benefits' },
    ],
});

// Interactive Sections
Builder.register('insertMenu', {
    name: 'Interactive Sections',
    items: [
        { name: BUILDER_DIVIDER_NAMES.ShavingAndWaxingCalc },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S1Hero },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S2Icons },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S3How },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S4WhyChoose },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S5BeforeAfter },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S6FAQs },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S7SubCategories },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S8MixedMedia },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S9PressRelease },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S10PressReleasePost },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S11Awards },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S12Reviews },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S13LHR },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S14WhatToExpect },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S15TwoSections },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S16BackgroundImage },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.BuilderTestComponent },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S17ToggleTabs },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S18Video },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S19Timeline },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S20Choices },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S31StateHero },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S32MapView },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S33CondensedSpecial },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S34Dropdowns },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S35ClinicInfo },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S36Staff },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S37ReviewsOverall },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S38NearbyLocations },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S39AdBanner },
        { name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S40Breadcrumbs },
    ],
});

// Videos
Builder.register('insertMenu', {
    name: 'Videos Sections',
    items: [
        { item: BUILDER_DIVIDER_NAMES.ReasonsLHRVimeo, name: 'Reasons LHR Vimeo' },
        { name: BUILDER_DIVIDER_NAMES.WhatCustomersSay },
    ],
});

// Hero
Builder.register('insertMenu', {
    name: 'Hero Sections',
    items: [
        { name: BUILDER_DIVIDER_NAMES.DynamicHero },
        { name: BUILDER_DIVIDER_NAMES.HeroWithImageAndLinkOnly },
        { name: BUILDER_DIVIDER_NAMES.DynamicHeroV2 },
        { name: BUILDER_DIVIDER_NAMES.LandingPageHero },
        { name: BUILDER_HERO_COMPONENTS_NAMES.BrandPartnerHero },
    ],
});

// Blog Sections
Builder.register('insertMenu', {
    name: 'Blog Sections',
    items: [
        { name: BUILDER_DIVIDER_NAMES.AboutMilanSection },
        { name: BUILDER_DIVIDER_NAMES.AboutAuthor },
        { name: BUILDER_DIVIDER_NAMES.PullQuote },
        { name: BUILDER_DIVIDER_NAMES.PopularBlogs },
        { name: BUILDER_DIVIDER_NAMES.AuthorAvatarHero },
        { name: BUILDER_DIVIDER_NAMES.AuthorHero },
        { name: BUILDER_DIVIDER_NAMES.BlogPostHero },
        { name: BUILDER_DIVIDER_NAMES.ConsultationSection },
        { name: BUILDER_DIVIDER_NAMES.SectionWithImage },
        { name: BUILDER_BLOG_COMPONENTS_NAMES.BlogLayout },
        { name: BUILDER_DIVIDER_NAMES.BlogTextSection },
        { name: BUILDER_BLOG_COMPONENTS_NAMES.BlogFAQs },
        { name: BUILDER_BLOG_COMPONENTS_NAMES.BlogHeroCarousel },
        { name: BUILDER_BLOG_COMPONENTS_NAMES.OurLatestBlogs },
    ],
});
